import get from "lodash/get";
import Collapse from "@material-ui/core/Collapse";
import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import Select from "react-select";
import { bindActionCreators } from "redux";
import { CommonReducerAction, setHelperText } from "../../../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../../../Actions/LanguageAction";
import CheckImg from "../../../../../../../Assets/Images/aaa.png";
import InputValues from "../../../../../../../Component/InputValues";
import { ReducersTypes } from "../../../../../../../Constants";
import LeavePlan from "..";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});
const ParentState = {
  leaveid: null,
  isaccrual: false,
  isunusedforward: false,
  isprobationaccurallimit: false,
  probationaccurallimit: 0,
  creditlimitinnonaccural: 0,
  unusedprobationleavetypeid: null,
  accuralfrequencytype: { displayname: null, displayvalue: null },
};
class LeaveBalanceAvailable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...ParentState,
      ParentIndex: props.ParentIndex || 0,
      leavetypeid: props.leavetypeid,
      reqTypeList: [
        { displayname: "Beginning of Month", displayvalue: 1 },
        { displayname: "End of Month", displayvalue: 2 },
        { displayname: "Beginning of Quater", displayvalue: 3 },
        { displayname: "End of Quater", displayvalue: 4 },
        { displayname: "Half Year", displayvalue: 5 },
      ],
    };

    this.onBeforeUpload = this.onBeforeUpload.bind(this);
  }

  componentWillMount() {
    this.SetValues(this.props);
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.onBeforeUpload);
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onBeforeUpload);
  }

  onBeforeUpload(e) {
    e.returnValue = "Are you sure you want to close the window/tab?";
  }

  componentWillReceiveProps(props) {
    if (this.state.ParentIndex != props.ParentIndex) {
      this.setState({ ParentIndex: props.ParentIndex }, () => this.SetValues(props));
    }
    if (this.state.leavetypeid != props.leavetypeid) {
      this.setState({ leavetypeid: props.leavetypeid });
    }
    const nextisprorate = get(
      this.props,
      `InitLeavesPolicy.policy[${props.ParentIndex}].isprorate`,
      "",
    );
    const nextisaccrural = get(
      this.props,
      `InitLeavesPolicy.policy[${props.ParentIndex}].isaccrural`,
      "",
    );
    if (
      !nextisaccrural
      && nextisprorate != null
      && !nextisprorate
      && nextisprorate != this.state.isaccrual
      && this.state.isaccrual
    ) {
      this.setState({ ...ParentState });
    }
  }

  SetValues(props) {
    const { ParentIndex } = props;
    if (props.InitLeavesPolicy.policy[ParentIndex]) {
      const { InitLeavesPolicy } = props;

      this.setState({
        ParentIndex,
        leavetypeid: props.leavetypeid,
        isaccrual: InitLeavesPolicy.policy[ParentIndex].isaccrual,
        accuralfrequencytype: InitLeavesPolicy.policy[ParentIndex].accuralfrequencytype
          ? this.state.reqTypeList.find(
              (x) => x.displayvalue == InitLeavesPolicy.policy[ParentIndex].accuralfrequencytype,
            )
          : { displayname: null, displayvalue: null },
        isunusedforward: InitLeavesPolicy.policy[ParentIndex].isunusedforward,
        isprobationaccurallimit: InitLeavesPolicy.policy[ParentIndex].isprobationaccurallimit,
        probationaccurallimit: InitLeavesPolicy.policy[ParentIndex].probationaccurallimit,
        creditlimitinnonaccural: InitLeavesPolicy.policy[ParentIndex].creditlimitinnonaccural,
        unusedprobationleavetypeid: InitLeavesPolicy.policy[ParentIndex].unusedprobationleavetypeid,
      });
    } else {
      this.setState({ ...ParentState });
    }
  }

  setHelperText = (key) => {
    this.props.setHelperText({
      helperText: this.props.Language ? this.props.Language.extratimepolicy[key] : "",
    });
  };

  handleChange(name, ...arg) {
    console.log("arg[0]: ", arg[0]);
    switch (name) {
      case "isaccrual":
        this.setState(
          {
            [name]: arg[0],
            accuralfrequencytype: { displayname: null, displayvalue: null },
            isunusedforward: false,
            unusedprobationleavetypeid: null,
            isprobationaccurallimit: false,
            probationaccurallimit: 0,
            creditlimitinnonaccural: 0,
          },
          () => {
            if (this.state.isaccrual) {
              const accuralfrequencytype = this.state.reqTypeList.find((x) => x.displayvalue == 1);
              this.setState({ accuralfrequencytype });
            }
            this.UpdateReducer();
          },
        );
        break;
      case "isunusedforward":
        this.setState({ [name]: arg[0], unusedprobationleavetypeid: 1 }, () => this.UpdateReducer());
        break;
      case "accuralfrequencytype":
        this.setState(
          {
            [name]: arg[0],
            isunusedforward:
              arg[0].displayvalue == 2 || arg[0].displayvalue == 4
                ? true
                : this.state.isunusedforward,
          },
          () => this.UpdateReducer(),
        );
        break;
      case "unusedprobationleavetypeid":
        this.setState({ [name]: arg[0] }, () => this.UpdateReducer());
        break;
      case "isprobationaccurallimit":
        this.setState(
          {
            [name]: arg[0],
            probationaccurallimit: 0,
            creditlimitinnonaccural: 0,
            unusedprobationleavetypeid: null,
          },
          () => {
            this.UpdateReducer();
          },
        );
        break;
      default:
        break;
    }
  }

  UpdateReducer = () => {
    const { ParentIndex } = this.state;
    const { InitLeavesPolicy } = this.props;
    if (!InitLeavesPolicy.policy[ParentIndex]) {
      const plan = LeavePlan.find((x) => x.leavetypeid == this.state.leavetypeid);
      InitLeavesPolicy.policy[ParentIndex] = plan.Reducer;
    }
    InitLeavesPolicy.policy[ParentIndex] = {
      ...InitLeavesPolicy.policy[ParentIndex],
      isaccrual: this.state.isaccrual,
      accuralfrequencytype: this.state.accuralfrequencytype.displayvalue,
      isunusedforward: this.state.isunusedforward,
      isprobationaccurallimit: this.state.isprobationaccurallimit,
      probationaccurallimit: this.state.probationaccurallimit,
      creditlimitinnonaccural: this.state.creditlimitinnonaccural,
      unusedprobationleavetypeid: this.state.unusedprobationleavetypeid,
    };
    this.props.CommonReducerAction(ReducersTypes.LEAVESPOLICY, InitLeavesPolicy);
  };

  CommonNumberChange = (name, max, event) => {
    const numbers = /^[0-9]+$/;
    if (event.target.value.match(numbers)) {
      let value;
      if (Number(event.target.value) > Number(max) || Number.isNaN(event.target.value)) value = this.state[name];
      else value = Number(event.target.value);
      this.setState({ [name]: value }, () => this.UpdateReducer());
    }
  };

  render() {
    const language = this.props.Language.extratimepolicy;
    const isprorate = get(
      this.props,
      `InitLeavesPolicy.policy[${get(this.props, "ParentIndex", "")}].isprorate`,
      "",
    );
    const isunusedforwarddisabled = get(this.state, "accuralfrequencytype.displayvalue", "") == 2
      || get(this.state, "accuralfrequencytype.displayvalue", "") == 4;
    return (
      <IntlProvider locale="en" messages={language}>
        {/* 4 */}
        <div>
          <div className="inner-wrapper margin-top-20 opaque">
            <p className="form-sub-header">
              <FormattedMessage
                id="LbAvailableForUse"
                defaultMessage="When will the leave balance be available for employees to use?"
              />
            </p>
            <div
              className={`depedent-select-list ${!isprorate ? "div-disabled bg-color-f4f4f4" : ""}`}
              onClick={() => this.handleChange("isaccrual", true)}
              aria-expanded={this.state.isaccrual}
            >
              <span>
                <FormattedMessage
                  id="LbBalanceWillAccrued"
                  defaultMessage="Leave balance will be accrued"
                />
              </span>
              {this.state.isaccrual == true ? (
                <span className="floatright">
                  <img src={CheckImg} height="20" />
                </span>
              ) : (
                <span className="not-selected " />
              )}
            </div>
            <div className="et-level2">
              <Collapse
                in={this.state.isaccrual}
                timeout="auto"
                unmountOnExit
                className="padding30 overflow-initial"
              >
                <p className="depedent-select-list-head">
                  <FormattedMessage
                    id="LbAccrueLeaves"
                    defaultMessage="How do you want to accrue this leave?"
                  />
                </p>
                <div className="margin-top-8 margin-bottom-20">
                  <Select
                    autofocus
                    placeholder="Select"
                    options={this.state.reqTypeList}
                    getOptionLabel={(option) => option.displayname}
                    getOptionValue={(option) => option.displayvalue}
                    onChange={this.handleChange.bind(this, "accuralfrequencytype")}
                    value={this.state.accuralfrequencytype}
                    className="width58"
                  />
                </div>
                {/* 2 */}
                <p className="depedent-select-list-head">
                  <FormattedMessage
                    id="LbForwardLeaves"
                    defaultMessage="Forward unused leaves to next month/quarter ?"
                  />
                </p>
                <div
                  className={`depedent-select-list ${isunusedforwarddisabled && "div-disabled"}`}
                  onClick={() => this.handleChange("isunusedforward", true)}
                  aria-expanded={this.state.isunusedforward}
                >
                  <span>
                    <FormattedMessage id="LbYes" defaultMessage="Yes" />
                  </span>
                  {this.state.isunusedforward == true ? (
                    <span className="floatright">
                      <img src={CheckImg} height="20" />
                    </span>
                  ) : (
                    <span className="not-selected " />
                  )}
                </div>
                <div
                  className={`depedent-select-list ${isunusedforwarddisabled && "div-disabled"}`}
                  onClick={() => this.handleChange("isunusedforward", false)}
                  aria-expanded={!this.state.isunusedforward}
                >
                  <span>
                    <FormattedMessage id="LbNo" defaultMessage="No" />
                  </span>
                  {this.state.isunusedforward == false ? (
                    <span className="floatright">
                      <img src={CheckImg} height="20" />
                    </span>
                  ) : (
                    <span className="not-selected " />
                  )}
                </div>
                {/* 3 */}
              </Collapse>
            </div>
            <div
              className="depedent-select-list"
              onClick={() => this.handleChange("isaccrual", false)}
              aria-expanded={this.state.isaccrual == false}
            >
              <span>
                <FormattedMessage
                  id="LbCreditedAtOnce"
                  defaultMessage="Leave balance will be credited all at once"
                />
              </span>
              {this.state.isaccrual == false ? (
                <span className="floatright">
                  <img src={CheckImg} height="20" />
                </span>
              ) : (
                <span className="not-selected " />
              )}
            </div>
            {this.props.leavetypeid != 11
            && <div className="et-level2">
              <Collapse
                in={this.state.isaccrual == false}
                timeout="auto"
                unmountOnExit
                className="padding30 overflow-initial"
              >
                <p className="depedent-select-list-head">
                  <FormattedMessage
                    id="__LbCreditDuringProbation"
                    defaultMessage="Do you want to limit credit during probation?"
                  />
                </p>
                <div
                  className="depedent-select-list"
                  onClick={() => this.handleChange("isprobationaccurallimit", true)}
                  aria-expanded={this.state.isprobationaccurallimit}
                >
                  <span>
                    <FormattedMessage id="LbYes" defaultMessage="Yes" />
                  </span>
                  {this.state.isprobationaccurallimit == true ? (
                    <span className="floatright">
                      <img src={CheckImg} height="20" />
                    </span>
                  ) : (
                    <span className="not-selected " />
                  )}
                </div>
                <div className="et-level3">
                  <Collapse
                    in={this.state.isprobationaccurallimit}
                    timeout="auto"
                    unmountOnExit
                    className="padding30 overflow-initial"
                  >
                    <FormattedMessage id="LbCreditOnly" defaultMessage="Credit only" />
                    <InputValues
                      min="0"
                      max="28"
                      field="probationaccurallimit"
                      onChange={this.CommonNumberChange.bind(this, "probationaccurallimit", 28)}
                      value={this.state.probationaccurallimit}
                      defaultvalue={this.state.probationaccurallimit}
                    />

                    <FormattedMessage
                      id="LbLeavesTillProbationEnd"
                      defaultMessage=" leave(s) until probation ends"
                    />
                  </Collapse>
                </div>
                <div
                  className="depedent-select-list"
                  onClick={() => this.handleChange("isprobationaccurallimit", false)}
                  aria-expanded={!this.state.isprobationaccurallimit}
                >
                  <span>
                    <FormattedMessage id="LbNo" defaultMessage="No" />
                  </span>
                  {this.state.isprobationaccurallimit == false ? (
                    <span className="floatright">
                      <img src={CheckImg} height="20" />
                    </span>
                  ) : (
                    <span className="not-selected " />
                  )}
                </div>
              </Collapse>
            </div>
            }
          </div>
        </div>
        {/* <Button variant="contained" color="primary" onClick={() => this.validateNext()}>
                        Next
                    </Button> */}
      </IntlProvider>
    );
  }
}
const mapStateToProps = (state) => ({
    Language: state.LanguageAction.Language,
    InitLeavesPolicy: state.InitLeavesPolicy,
  });
const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      CommonReducerAction: (type, data) => CommonReducerAction(type, data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(LeaveBalanceAvailable)));
